import React, { createContext, useState, useContext } from "react";

//Util
import { fn_getTokenUsuario } from "@/frontend/utils/sessao";

//API
import { api_logout } from "@/frontend/services/api/api_others";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [sessaoUsuario, setSessaoUsuario] = useState(() => {
    const sessaoUsuarioData = sessionStorage.getItem("sessaoUsuario");
    return sessaoUsuarioData ? JSON.parse(sessaoUsuarioData) : null;
  });

  /*
   * Login do usuário no sistema, colocando os dados na sessão
   */
  function signIn(response) {
    const sessaoUsuarioData = response.sessaoUsuario;

    sessionStorage.setItem("sessaoUsuario", JSON.stringify(sessaoUsuarioData));
    setSessaoUsuario(sessaoUsuarioData);

    //Coloca a data do último login na sessão separadamente (ela pode ser alterada)
    if (sessaoUsuarioData.usuario.data_ultimo_login) {
      sessionStorage.setItem(
        "dataUltimoLogin",
        sessaoUsuarioData.usuario.data_ultimo_login,
      );
    }

    //Cache navegador
    localStorage.setItem("pathTenant", sessaoUsuarioData.path);
  }

  /*
   * Logout do usuário no sistema, removendo os dados na sessão
   */
  function signOut() {
    //Avisa o servidor da saída (consulta de usuários conectados), sem esperar a resposta.
    //OBS: Só com sessão: a página inicial também chama o signOut sem ninguém logado
    const token = fn_getTokenUsuario(sessaoUsuario);
    if (token) {
      api_logout(token);
    }

    sessionStorage.removeItem("sessaoUsuario");
    sessionStorage.removeItem("dataUltimoLogin");
    setSessaoUsuario(null);
  }

  /*
   * Coloca na sessão a data do último login para controle da alteração de senha no primeiro acesso
   */
  function setDataUltimoLogin(dataUltimoLogin) {
    sessionStorage.setItem("dataUltimoLogin", dataUltimoLogin);
  }

  return (
    <AuthContext.Provider
      value={{
        signed: !!sessaoUsuario,
        sessaoUsuario,
        signIn,
        signOut,
        setDataUltimoLogin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("Não autorizado!");
  }

  return context;
};
